import { render, staticRenderFns } from "./NavDetail.vue?vue&type=template&id=97621682&scoped=true&"
import script from "./NavDetail.vue?vue&type=script&lang=js&"
export * from "./NavDetail.vue?vue&type=script&lang=js&"
import style0 from "./NavDetail.vue?vue&type=style&index=0&id=97621682&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97621682",
  null
  
)

export default component.exports